// projects/humanresources-personnel/src/assets/i18n/*/hr-per-hierarchy-group-detail.json
export class HrPerHierarchyGroupDetailKey {
    private static readonly keyPrefix = 'hrPerHieGrpDetail';
    public static title = `${HrPerHierarchyGroupDetailKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerHierarchyGroupDetailKey.keyPrefix}.pageHeader`;
    public static groupId = `${HrPerHierarchyGroupDetailKey.keyPrefix}.groupId`;
    public static objectConnectionId = `${HrPerHierarchyGroupDetailKey.keyPrefix}.objectConnectionId`;
}
